#import "../fragments/email-automation-status.graphql"

mutation EmailAutomationStatusCancel($input: EmailAutomationStatusCancelInput!) {
    emailAutomationStatusCancel(input: $input) {
        emailAutomationStatus {
            ...EmailAutomationStatus
        }
    }
}
